









































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import StrHelper from "@/lib/Common/strhelper";
import ChooseDevice from "./choosedevice.vue";
import Moment from "moment-timezone";

class PageMeterRequest extends PageRequest {
    keyword: string = "";
    startTime: string;
    endTime: string;
    deviceId: any[] = [];
    page: number;
    pageSize: number;
    sortBy: string;
    descending: boolean;
    filterFileds: any;
}

@Component({
    components: { ChooseDevice },
})
export default class EletricalParameters extends AbpBase {
    //filters
    pagerequest: PageMeterRequest = new PageMeterRequest();
    chooseModal: boolean = false; //选择窗体是否显示
    //choosemeters: Array<any> = []; //已经选择表计

    height: number = 300;
    loadingdata: boolean = false;
    //显示选择表计框
    showchoosedevice() {
        this.chooseModal = true;
    }
    //获取子组件回传值
    getdevicelist(data: any) {
        this.pagerequest.deviceId = [];
        data.forEach((ele) => {
            this.pagerequest.deviceId.push(ele.id);
            if (this.pagerequest.keyword.length == 0) {
                this.pagerequest.keyword = ele.meterNo + '>>' + ele.roomNo;
            } else {
                this.pagerequest.keyword = this.pagerequest.keyword + ";" + ele.meterNo + '>>' + ele.roomNo;
            }
        });
    }
    cleardata() {
        this.pagerequest.deviceId = [];
    }
    //改变排序
    changeSort(key) {
        if (key.order === "desc" || key.order === "normal") {
            this.pagerequest.sortBy = key.key;
            this.pagerequest.descending = true;
        } else {
            this.pagerequest.sortBy = key.key;
            this.pagerequest.descending = false;
        }
        this.getpage();
    }
    get list() {
        return this.$store.state.monitor.list;
    }
    get loading() {
        return this.$store.state.monitor.loading;
    }
    isActiveChange(val: number) {
        this.$store.commit("monitor/setCurrentPage", 1);
        this.getpage();
    }
    pageChange(page: number) {
        this.$store.commit("monitor/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("monitor/setPageSize", pagesize);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.pageSize = this.pageSize;
        this.pagerequest.page = this.currentPage;
        await this.$store.dispatch({ type: "monitor/getESRecordList", data: this.pagerequest, });
    }
    get pageSize() {
        return this.$store.state.monitor.pageSize;
    }
    get totalCount() {
        return this.$store.state.monitor.totalCount;
    }
    get currentPage() {
        return this.$store.state.monitor.currentPage;
    }
    //列信息
    columns = [
        {
            type: "index",
            width: 70,
            align: "left",
            fixed: "left",
            title: this.L("IndexNo"),
            sortId: 0,
        },
        {
            sortable: true,
            title: this.L("Meter"),
            key: "meterNo",
            resizable: true,
            width: 130,
            fixed: "left",
            sortId: 2,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.meterNo,
                        },
                    },
                    params.row.meterNo
                );
            },
        },
        {
            title: this.L("LastReadTime"),
            key: "readTime",
            sortable: true,
            sortType: "desc",
            width: 150,
            fixed: "right",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.readTime == null
                        ? ""
                        : Moment(params.row.readTime).format("YYYY-MM-DD HH:mm:ss")
                );
            },
        },
        {
            title: this.L("Organizations"),
            key: "organizationId",
            width: 130,
            resizable: true,
            sortId: 19,
            render: (h: any, params: any) => {
                let id = params.row.organizationId;
                let ite = JSON.parse(localStorage.getItem("organizations"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title:
                                    info.length > 0 ? info[0].displayName : this.L("Unknown"),
                            },
                        },
                        info.length > 0 ? info[0].displayName : this.L("Unknown")
                    ),
                ]);
            },
        },
        {
            title: this.L("Areas"),
            key: "areaId",
            sortable: true,
            width: 130,
            resizable: true,
            sortId: 20,
            render: (h: any, params: any) => {
                let id = params.row.areaId;
                let ite = JSON.parse(localStorage.getItem("areas"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
                            },
                        },
                        info.length > 0 ? info[0].fullName : this.L("Unknown")
                    ),
                ]);
            },
        },
        {
            title: this.L("Va"),
            key: "va",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.va == null
                        ? ""
                        : parseFloat(params.row.va).toFixed(1)
                );
            },
        },
        {
            title: this.L("Vb"),
            key: "vb",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vb == null
                        ? ""
                        : parseFloat(params.row.vb).toFixed(1)
                );
            },
        },
        {
            title: this.L("Vc"),
            key: "vc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vc == null
                        ? ""
                        : parseFloat(params.row.vc).toFixed(1)
                );
            },
        },
        {
            title: this.L("Vab"),
            key: "vab",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vab == null
                        ? ""
                        : parseFloat(params.row.vab).toFixed(1)
                );
            },
        },
        {
            title: this.L("Vbc"),
            key: "vbc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vbc == null
                        ? ""
                        : parseFloat(params.row.vbc).toFixed(1)
                );
            },
        },
        {
            title: this.L("Vca"),
            key: "vca",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vca == null
                        ? ""
                        : parseFloat(params.row.vca).toFixed(1)
                );
            },
        },
        {
            title: this.L("Ia"),
            key: "ia",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.ia == null
                        ? ""
                        : parseFloat(params.row.ia).toFixed(3)
                );
            },
        },
        {
            title: this.L("Ib"),
            key: "ib",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.ib == null
                        ? ""
                        : parseFloat(params.row.ib).toFixed(3)
                );
            },
        },
        {
            title: this.L("Ic"),
            key: "ic",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.ic == null
                        ? ""
                        : parseFloat(params.row.ic).toFixed(3)
                );
            },
        },
        {
            title: this.L("F"),
            key: "fa",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.fa == null
                        ? ""
                        : parseFloat(params.row.fa).toFixed(1)
                );
            },
        },
        {
            title: this.L("Pt"),
            key: "pt",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pt == null
                        ? ""
                        : parseFloat(params.row.pt).toFixed(4)
                );
            },
        },
        {
            title: this.L("Pa"),
            key: "pa",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pa == null
                        ? ""
                        : parseFloat(params.row.pa).toFixed(4)
                );
            },
        },
        {
            title: this.L("Pb"),
            key: "pb",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pb == null
                        ? ""
                        : parseFloat(params.row.pb).toFixed(4)
                );
            },
        },
        {
            title: this.L("Pc"),
            key: "pc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pc == null
                        ? ""
                        : parseFloat(params.row.pc).toFixed(4)
                );
            },
        },
        {
            title: this.L("Qt"),
            key: "qt",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.qt == null
                        ? ""
                        : parseFloat(params.row.qt).toFixed(4)
                );
            },
        },
        {
            title: this.L("Qa"),
            key: "qa",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.qa == null
                        ? ""
                        : parseFloat(params.row.qa).toFixed(4)
                );
            },
        },
        {
            title: this.L("Qb"),
            key: "qb",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.qb == null
                        ? ""
                        : parseFloat(params.row.qb).toFixed(4)
                );
            },
        },
        {
            title: this.L("Qc"),
            key: "qc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.qc == null
                        ? ""
                        : parseFloat(params.row.qc).toFixed(4)
                );
            },
        },
        {
            title: this.L("St"),
            key: "st",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.st == null
                        ? ""
                        : parseFloat(params.row.st).toFixed(4)
                );
            },
        },
        {
            title: this.L("Sa"),
            key: "sa",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.sa == null
                        ? ""
                        : parseFloat(params.row.sa).toFixed(4)
                );
            },
        },
        {
            title: this.L("Sb"),
            key: "sb",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.sb == null
                        ? ""
                        : parseFloat(params.row.sb).toFixed(4)
                );
            },
        },
        {
            title: this.L("Sc"),
            key: "sc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.sc == null
                        ? ""
                        : parseFloat(params.row.sc).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFt"),
            key: "pFt",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pFt == null
                        ? ""
                        : parseFloat(params.row.pFt).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFa"),
            key: "pFa",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pFa == null
                        ? ""
                        : parseFloat(params.row.pFa).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFb"),
            key: "pFb",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pFb == null
                        ? ""
                        : parseFloat(params.row.pFb).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFc"),
            key: "pFc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pFc == null
                        ? ""
                        : parseFloat(params.row.pFc).toFixed(4)
                );
            },
        },
        {
            title: this.L("MaxImum"),
            key: "maxImum",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.maxImum == null
                        ? ""
                        : parseFloat(params.row.maxImum).toFixed(2)
                );
            },
        },
        {
            title: this.L("MaxImumTime"),
            key: "maxImumTime",
            align: "center",
            width: 130,
        },
        {
            title: this.L("ReadNum"),
            key: "ept",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.ept == null
                        ? ""
                        : parseFloat(params.row.ept).toFixed(4)
                );
            },
        },
        {
            title: this.L("Tip"),
            key: "eptj",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.eptj == null
                        ? ""
                        : parseFloat(params.row.eptj).toFixed(4)
                );
            },
        },
        {
            title: this.L("Peak"),
            key: "eptf",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.eptf == null
                        ? ""
                        : parseFloat(params.row.eptf).toFixed(4)
                );
            },
        },
        {
            title: this.L("Flat"),
            key: "eptp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.eptp == null
                        ? ""
                        : parseFloat(params.row.eptp).toFixed(4)
                );
            },
        },
        {
            title: this.L("Valley"),
            key: "eptg",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.eptg == null
                        ? ""
                        : parseFloat(params.row.eptg).toFixed(4)
                );
            },
        },
        {
            title: this.L("P"),
            key: "p",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.p == null
                        ? ""
                        : parseFloat(params.row.p).toFixed(4)
                );
            },
        },
        {
            title: this.L("Eqt"),
            key: "eqt",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.eqt == null
                        ? ""
                        : parseFloat(params.row.eqt).toFixed(4)
                );
            },
        },
        {
            title: this.L("Pep"),
            key: "pep",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pep == null
                        ? ""
                        : parseFloat(params.row.pep).toFixed(4)
                );
            },
        },
        {
            title: this.L("Mep"),
            key: "mep",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mep == null
                        ? ""
                        : parseFloat(params.row.mep).toFixed(4)
                );
            },
        },
        {
            title: this.L("Meq"),
            key: "meq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.meq == null
                        ? ""
                        : parseFloat(params.row.meq).toFixed(4)
                );
            },
        },
        {
            title: this.L("VLNavg"),
            key: "vLNavg",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vLNavg == null
                        ? ""
                        : parseFloat(params.row.vLNavg).toFixed(1)
                );
            },
        },
        {
            title: this.L("VLLage"),
            key: "vLLage",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vLLage == null
                        ? ""
                        : parseFloat(params.row.vLLage).toFixed(1)
                );
            },
        },
        {
            title: this.L("IAvg"),
            key: "iAvg",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.iAvg == null
                        ? ""
                        : parseFloat(params.row.iAvg).toFixed(3)
                );
            },
        },
        {
            title: this.L("IM"),
            key: "iM",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.iM == null
                        ? ""
                        : parseFloat(params.row.iM).toFixed(3)
                );
            },
        },
        {
            title: this.L("PTipEp"),
            key: "pTipEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pTipEp == null
                        ? ""
                        : parseFloat(params.row.pTipEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("PPeakEp"),
            key: "pPeakEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pPeakEp == null
                        ? ""
                        : parseFloat(params.row.pPeakEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFlatEp"),
            key: "pFlatEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pFlatEp == null
                        ? ""
                        : parseFloat(params.row.pFlatEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("PValleyEp"),
            key: "pValleyEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pValleyEp == null
                        ? ""
                        : parseFloat(params.row.pValleyEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("MTipEp"),
            key: "mTipEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mTipEp == null
                        ? ""
                        : parseFloat(params.row.mTipEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("MPeakEp"),
            key: "mPeakEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mPeakEp == null
                        ? ""
                        : parseFloat(params.row.mPeakEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("MFlatEp"),
            key: "mFlatEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mFlatEp == null
                        ? ""
                        : parseFloat(params.row.mFlatEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("MValleyEp"),
            key: "mValleyEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mValleyEp == null
                        ? ""
                        : parseFloat(params.row.mValleyEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("PTipEq"),
            key: "pTipEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pTipEq == null
                        ? ""
                        : parseFloat(params.row.pTipEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("PPeakEq"),
            key: "pPeakEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pPeakEq == null
                        ? ""
                        : parseFloat(params.row.pPeakEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFlatEq"),
            key: "pFlatEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pFlatEq == null
                        ? ""
                        : parseFloat(params.row.pFlatEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("PValleyEq"),
            key: "pValleyEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pValleyEq == null
                        ? ""
                        : parseFloat(params.row.pValleyEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("MTipEq"),
            key: "mTipEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mTipEq == null
                        ? ""
                        : parseFloat(params.row.mTipEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("MPeakEq"),
            key: "mPeakEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mPeakEq == null
                        ? ""
                        : parseFloat(params.row.mPeakEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("MFlatEq"),
            key: "mFlatEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mFlatEq == null
                        ? ""
                        : parseFloat(params.row.mFlatEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("MValleyEq"),
            key: "mValleyEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mValleyEp == null
                        ? ""
                        : parseFloat(params.row.mValleyEp).toFixed(4)
                );
            },
        },
    ];
    changdate(val) {
        if (val.length > 1) {
            this.pagerequest.startTime = val[0];
            this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
                .endOf("day")
                .format("YYYY-MM-DD HH:mm:ss");
        }
    }
    async created() {
        this.pagerequest.startTime = Moment().add(-7, "days").startOf("day").format("YYYY-MM-DD HH:mm:ss");
        this.pagerequest.endTime = Moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
        this.pagerequest.sortBy = "readTime";
        this.pagerequest.descending = true;
        this.getpage();
    }
    data() {
        return {
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
            datepicker: {
                shortcuts: [
                    {
                        text: this.L("OneWeek"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("OneMonth"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("ThreeMonths"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        },
                    },
                ],
            },
        };
    }
    mounted() {
        if (window.innerHeight > 800) {
            this.height = window.innerHeight - 380;
        } else {
            this.height = window.innerHeight - 420;
        }
    }
}
